<template>
    <div class="questionaire">
        <div class="questionaire_overview">
            <div class="questionaire_sections deskop">
                <QuestionStep :chapter='operationalTransferability'
                    title='operationalTransferability'
                    step='1'
                    :completed="(sectionCompleted >= 1 ? 1 : 0)"
                    :active="(sectionCompleted === 0 || 'operationalTransferability' === this.sectionTitle ? true : false)"
                    :activeQuestion="activeQuestion"
                    @handleQuestionSelected="handleQuestionSelected"/>
                <QuestionStep :chapter='structuralTransferability'
                    title='structuralTransferability'
                    step='2'
                    :completed="(sectionCompleted >= 2 ? 2 : 0)"
                    :active="(sectionCompleted === 1 || 'structuralTransferability' === this.sectionTitle ? true : false)"
                    :activeQuestion="activeQuestion"
                    @handleQuestionSelected="handleQuestionSelected"/>
                <QuestionStep
                    :chapter='emotionalTransferability'
                    title='emotionalTransferability'
                    step='3'
                    :completed="(sectionCompleted >= 3 ? 3 : 0)"
                    :active="(sectionCompleted === 2 || 'emotionalTransferability' === this.sectionTitle ? true : false)"
                    :activeQuestion="activeQuestion"
                    @handleQuestionSelected="handleQuestionSelected"/>
                <QuestionStep
                    :chapter='sustainableProfitability'
                    title='sustainableProfitability'
                    step='4'
                    :completed="(sectionCompleted >= 4 ? 4 : 0)"
                    :active="(sectionCompleted === 3 || 'sustainableProfitability' === this.sectionTitle ? true : false)"
                    :activeQuestion="activeQuestion"
                    @handleQuestionSelected="handleQuestionSelected"/>
            </div>
            <div class="questionaire_sections mobile">
                <QuestionStep v-if="!hideSection || sectionCompleted === 0"
                    :chapter='operationalTransferability'
                    title='operationalTransferability'
                    step='1'
                    :completed="(sectionCompleted >= 1 ? 1 : 0)"
                    :active="(sectionCompleted === 0 || 'operationalTransferability' === this.sectionTitle ? true : false)"
                    :activeQuestion="activeQuestion"
                    @handleQuestionSelected="handleQuestionSelected"/>
                <QuestionStep v-if="!hideSection || sectionCompleted === 1"
                    :chapter='structuralTransferability'
                    title='structuralTransferability'
                    step='2'
                    :completed="(sectionCompleted >= 2 ? 2 : 0)"
                    :active="(sectionCompleted === 1 || 'structuralTransferability' === this.sectionTitle ? true : false)"
                    :activeQuestion="activeQuestion"
                    @handleQuestionSelected="handleQuestionSelected"/>
                <QuestionStep v-if="!hideSection || sectionCompleted === 2"
                    :chapter='emotionalTransferability'
                    title='emotionalTransferability'
                    step='3'
                    :completed="(sectionCompleted >= 3 ? 3 : 0)"
                    :active="(sectionCompleted === 2 || 'emotionalTransferability' === this.sectionTitle ? true : false)"
                    :activeQuestion="activeQuestion"
                    @handleQuestionSelected="handleQuestionSelected"/>
                <QuestionStep v-if="!hideSection || sectionCompleted === 3"
                    :chapter='sustainableProfitability'
                    title='sustainableProfitability'
                    step='4'
                    :completed="(sectionCompleted >= 4 ? 4 : 0)"
                    :active="(sectionCompleted === 3 || 'sustainableProfitability' === this.sectionTitle ? true : false)"
                    :activeQuestion="activeQuestion"
                    @handleQuestionSelected="handleQuestionSelected"/>
                <div class="questionaire_sections_inactive">
                    <SvgIcon @click="hideSection = !hideSection" :type="(hideSection ? 'icon_arrow_down_red' : 'icon_arrow_up_black')"/>
                    <div @click="hideSection = !hideSection" class="hide_show">
                         {{ hideSection ? $t('general:showMore') : $t('general:showless') }}
                    </div>
                </div>
            </div>
            <div v-if="chapterIntro" class="questionaire_visual" tabindex="0" id="illustrationContainer">
                <div class="questionaire_image">
                    <img :src="require(`@/assets/images/backgrounds/${sectionTitle}.svg`)" :alt="altSectionTitle">
                </div>
                <div class="questionaire_content">
                    <div class="questionaire_content_chapter">{{ $t('general:chapter') }} {{ chapterNumber }}</div>
                    <h1 class="questionaire_content_title">{{ $t('overview:'+sectionTitle+':pageTitle') }}</h1>
                    <p class="copy" v-html="$t('overview:'+sectionTitle+':copy')" />
                    <div class="btn-panel">
                        <button v-if="sectionTitle !== 'operationalTransferability'" class="prev btn btn-white"
                            @click="previousChapterLastQuestion()">
                            <SvgIcon type="icon_arrow_left" class="arrowicon_prev chevron_prev"/>
                            <SvgIcon type="horizontal_line_red" class="arrowicon_prev line_red_prev"/>
                            {{ $t('general:prev') }}
                        </button>
                        <button @click="openQuestionSection(sectionTitle)" class="btn btn-red">
                            {{ $t('general:next') }}
                            <SvgIcon type="horizontal_line_white" class="arrowicon line_white"/>
                            <SvgIcon type="icon_arrow_right" class="arrowicon chevron"/>
                        </button>
                    </div>
                </div>
            </div>
            <MultipleChoice v-else-if="openQuestion[0]"
                        :stepData="openQuestion[1]"
                        :section="openQuestion[0]"
                        :selectedAnswer="selectedAnswer"/>
            <MultipleChoice v-else-if="showFirstQuestion"
                        :stepData="showFirstQuestionData[1]"
                        :section="showFirstQuestionData[0]"
                        :selectedAnswer="selectedAnswer"/>
        </div>
    </div>
</template>

<script>
import operationalTransferability from '@/data/tasks/operationalTransferability.json'
import structuralTransferability from '@/data/tasks/structuralTransferability.json'
import emotionalTransferability from '@/data/tasks/emotionalTransferability.json'
import sustainableProfitability from '@/data/tasks/sustainableProfitability.json'
import answerHandling from '@/mixins/answerHandling'
import current from '@/mixins/current'
import QuestionStep from '@/components/questionTypes/QuestionStep'
import MultipleChoice from '@/components/questionTypes/MultipleChoice'
import SvgIcon from '@/components/SvgIcon'

export default {
    name: 'ChapterIntro',
    mixins: [current, answerHandling],
    components: {
        QuestionStep,
        MultipleChoice,
        SvgIcon
    },
    data: function() {
        return {
            openSections: [1],
            openQuestion: [],
            selectedAnswer: 0,
            activeQuestion: false,
            showFirstQuestion: false,
            showFirstQuestionData: [],
            hideSection: true,
            operationalTransferability: operationalTransferability,
            structuralTransferability: structuralTransferability,
            emotionalTransferability: emotionalTransferability,
            sustainableProfitability: sustainableProfitability
        }
    },
    mounted() {
        this.setChapterIntro(true)
        if (document.querySelector('.questionaire_visual') !== null) {
            document.querySelector('.questionaire_visual').focus()
        }
        if (document.querySelector('.questionText') !== null) {
            document.querySelector('.questionText').focus()
        }
        if (this.chapterIntro && window.innerWidth < 600) {
            setTimeout(() => {
                window.scrollTo({
                    top: document.getElementById('illustrationContainer').offsetTop + 84,
                    behavior: 'smooth'
                })
            }, 2000)
        }
    },
    updated() {
        if (document.querySelector('.questionaire_visual') !== null) {
            document.querySelector('.questionaire_visual').focus()
        }
        if (document.querySelector('.questionText') !== null) {
            document.querySelector('.questionText').focus()
        }
    },
    computed: {
        currentStep: function() {
            return this.$store.getters['app/currentStep']
        },
        chapterIntro: function() {
            return this.$store.getters['app/chapterIntro']
        },
        sectionCompleted: function() {
            return this.$store.getters['app/sectionCompleted']
        },
        sectionTitle: function() {
            return this.$store.getters['app/sectionTitle']
        },
        section: function() {
            return this.$store.getters['app/section']
        },
        activeQuestionStep: function() {
            return this.$store.getters['app/activeQuestionStep']
        },
        chapterNumber: function() {
            let chapter = 1
            if (this.sectionTitle === 'structuralTransferability') {
                chapter = 2
            } else if (this.sectionTitle === 'emotionalTransferability') {
                chapter = 3
            } else if (this.sectionTitle === 'sustainableProfitability') {
                chapter = 4
            }
            return chapter
        },
        altSectionTitle: function() {
            let altValue = this.$t('overview:operationalTransferability.altTag')
            if (this.sectionTitle === 'structuralTransferability') {
                altValue = this.$t('overview:structuralTransferability.altTag')
            } else if (this.sectionTitle === 'emotionalTransferability') {
                altValue = this.$t('overview:emotionalTransferability.altTag')
            } else if (this.sectionTitle === 'sustainableProfitability') {
                altValue = this.$t('overview:sustainableProfitability.altTag')
            }
            return altValue
        }
    },
    methods: {
        openCloseSection(sectionId) {
            if (this.openSections.includes(sectionId)) {
                var index = this.openSections.indexOf(sectionId)
                this.openSections.splice(index, 1)
            } else {
                this.openSections.push(sectionId)
            }
        },
        isSectionOpen(sectionId) {
            if (this.openSections.includes(sectionId)) {
                return 1
            } else {
                return 0
            }
        },
        openQuestionSection(sectionTitle) {
            this.showFirstQuestion = true
            this.activeQuestion = true
            this.openQuestion = []
            this.setChapterIntro(false)

            if (sectionTitle === 'operationalTransferability') {
                this.showFirstQuestionData = [sectionTitle, operationalTransferability.step[1]]
            } else if (sectionTitle === 'structuralTransferability') {
                this.showFirstQuestionData = [sectionTitle, structuralTransferability.step[1]]
            } else if (sectionTitle === 'emotionalTransferability') {
                this.showFirstQuestionData = [sectionTitle, emotionalTransferability.step[1]]
            } else if (sectionTitle === 'sustainableProfitability') {
                this.showFirstQuestionData = [sectionTitle, sustainableProfitability.step[1]]
            }
            this.setActiveQuestionStep(parseInt(this.showFirstQuestionData[1].step))
        },
        handleQuestionSelected(value, title) {
            this.openQuestion = [title, value]
            this.selectedAnswer = value.step
        },
        next: function(section, step, last, counter, type) {
            this.activeQuestion = false
            if (!last) {
                this.setChapterIntro(false)
                if (section === 'operationalTransferability') {
                    if (this.currentStep < parseInt(step) && type === 'next' && this.sectionCompleted < 1) {
                        this.incrementCurrent('step')
                        this.setSection(1)
                    }
                    this.openQuestion = [section, Object.values(this.operationalTransferability)[1][parseInt(step) + counter]]
                } else if (section === 'structuralTransferability') {
                    if (this.currentStep < parseInt(step) && type === 'next' && this.sectionCompleted < 2) {
                        this.incrementCurrent('step')
                        this.setSection(2)
                    }
                    this.openQuestion = [section, Object.values(this.structuralTransferability)[1][parseInt(step) + counter]]
                } else if (section === 'emotionalTransferability') {
                    if (this.currentStep < parseInt(step) && type === 'next' && this.sectionCompleted < 3) {
                        this.incrementCurrent('step')
                        this.setSection(3)
                    }
                    this.openQuestion = [section, Object.values(this.emotionalTransferability)[1][parseInt(step) + counter]]
                } else if (section === 'sustainableProfitability') {
                    if (this.currentStep < parseInt(step) && type === 'next' && this.sectionCompleted < 4) {
                        this.incrementCurrent('step')
                        this.setSection(4)
                    }
                    this.openQuestion = [section, Object.values(this.sustainableProfitability)[1][parseInt(step) + counter]]
                }
                this.setActiveQuestionStep(parseInt(this.openQuestion[1].step))
            } else {
                this.setChapterIntro(true)
                this.setActiveQuestionStep(0)
                if (section === 'operationalTransferability') {
                    if (this.sectionCompleted < 1) {
                        this.resetStep()
                        this.setSectionCompleted(1)
                    }
                    this.setSection(2)
                    this.setSectionTitle('structuralTransferability')
                } else if (section === 'structuralTransferability') {
                    if (this.sectionCompleted < 2) {
                        this.resetStep()
                        this.setSectionCompleted(2)
                    }
                    this.setSection(3)
                    this.setSectionTitle('emotionalTransferability')
                } else if (section === 'emotionalTransferability') {
                    if (this.sectionCompleted < 3) {
                        this.resetStep()
                        this.setSectionCompleted(3)
                    }
                    this.setSection(4)
                    this.setSectionTitle('sustainableProfitability')
                } else if (section === 'sustainableProfitability') {
                    if (this.sectionCompleted < 4) {
                        this.resetStep()
                        this.setSectionCompleted(4)
                    }
                }
            }
        },
        previousChapterLastQuestion: function() {
            this.setChapterIntro(false)
            if (this.sectionTitle === 'structuralTransferability') {
                this.setSectionTitle('operationalTransferability')
                this.openQuestion = ['operationalTransferability', Object.values(this.operationalTransferability)[1][4]]
            } else if (this.sectionTitle === 'emotionalTransferability') {
                this.setSectionTitle('structuralTransferability')
                this.openQuestion = ['structuralTransferability', Object.values(this.structuralTransferability)[1][4]]
            } else if (this.sectionTitle === 'sustainableProfitability') {
                this.setSectionTitle('emotionalTransferability')
                this.openQuestion = ['emotionalTransferability', Object.values(this.emotionalTransferability)[1][3]]
            }
            this.setActiveQuestionStep(parseInt(this.openQuestion[1].step))
        }
    }
}
</script>
